import React from "react";
import { connect } from "react-redux";
import BlackLogo from "../../assests/images/logo/black-logo.svg";
import WhiteLogo from "../../assests/images/logo/white-logo.svg";
import CelltopLogo from "../../assests/images/logo/celltop.svg";

// Keyed by hostname, so the www variants need their own entries - without them
// www.celltop.vip falls through to DefaultSVG and shows the wrong brand.
const SVG_MAP = {
  "phoneplay.me": {
    light: BlackLogo,
    dark: WhiteLogo,
  },
  "www.phoneplay.me": {
    light: BlackLogo,
    dark: WhiteLogo,
  },
  "celltop.vip": {
    light: CelltopLogo,
    dark: CelltopLogo,
  },
  "www.celltop.vip": {
    light: CelltopLogo,
    dark: CelltopLogo,
  },
};

const DefaultSVG = {
  light: BlackLogo,
  dark: WhiteLogo,
};

export const getLogo = (isDarkTheme) => {
  const hostname = window.location.hostname;
  return (
    SVG_MAP[hostname]?.[isDarkTheme ? "dark" : "light"] ||
    DefaultSVG[isDarkTheme ? "dark" : "light"]
  );
};

// True when the current hostname is a CellTop one.
export const isCelltopHost = () => getLogo(true) === CelltopLogo;

const DynamicLogo = ({ isDarkTheme, width, height, className }) => {
  const logoPath = getLogo(isDarkTheme);

  return (
    <img
      src={logoPath}
      alt="Logo"
      width={width}
      height={height}
      className={className}
    />
  );
};
const mapStateToProps = (state) => ({
  isDarktheme: state.darkTheme.isDarktheme,
});
export default connect(mapStateToProps)(DynamicLogo);
